<template>
  <footer class="footer">
    <div class="container-fluid d-flex flex-wrap justify-content-between">
      <div>
        <div class="copyright">Apolo © {{ year }}</div>
      </div>
      <div v-if="is_customer">
        <div v-if="seller_has_number" @click="redirectToSellerWhatsapp" class="copyright cursor-pointer">
          <img src="/img/icons/whatsapp.svg" class="whatsapp-icon">
          <i class="fas fa-whatsapp text-success" aria-hidden="true"></i>
          Falar com {{ seller_name }}
        </div>
      </div>
    </div>
  </footer>
</template>
<script>
export default {
  data() {
    return {
      seller_name: "Consultor",
      seller_has_number: false,
    };
  },
  computed: {
    year() {
      return new Date().getFullYear();
    },
  },
  mounted() {
    this.seller_name = this.$store.getters["user"].seller?.name ?? "Sem consultor";
    this.seller_has_number = this.$store.getters["user"].seller ? !!this.$store.getters["user"].seller.phone_number : "Sem telefone";
  },
  methods: {
    redirectToSellerWhatsapp() {
      let phone = !!this.$store.getters["user"].seller.phone_number
        ? this.$store.getters["user"].seller.phone_number.replace(/[^\d]+/g, "")
        : "";
      let text = "Olá, estou entrando contato pela plataforma Apolo.";
      window.open(
        `https://api.whatsapp.com/send?phone=${phone}&text=${text}`,
        "_blank"
      );
    },
  },
};
</script>
<style lang="scss" scoped>
$primary-color: #004E3E;

.footer {
  background-color: $primary-color;
}

.whatsapp-icon {
  width: 15px;
  height: 15px;
  color: white;
}
</style>
